import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalConfig } from "../../config/config";
import axios from "axios";
import { toast } from 'react-toastify';

// import { SelectListComponent } from "shared-components";
// const querystring = require("querystring");

const initialState = {
      transformationId: 0,
      transformationName: "",
      resourceFile: "",
      className: "",
      description: "",
      transformationVersion: "",
      statusCode: 0,
      securityContextId: 0,
      createUser: 0,
      createDate: new Date(),
      lastUpdateUser: 0,
      lastUpdateDate: new Date(),
      parameters: "",
      transformationTypeCode: 0,
    };
    
const ManageTransformer = ({ location }) => {
	const { id } = useParams();
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState([]);
  console.log('id - ' + id);
  const [state, setState] = useState(initialState);
  
  useEffect(() => {
    handleOnLoad();
  }, []);

  const handleOnLoad = (e) => {


	if (id > 0)
	{	
	
	  	try {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/transformations/${id}`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        setState(res.data);
      })
       .catch(error => {
    	      toast.error('Transformer retrieval failed - ' + JSON.stringify(error.response.data));
			    console.log(error.response.status);    // 404, 500, etc
    			console.log(error.response.data);      // error message from server
    			console.log(error.response.config.url); // exact URL it hit
  	});


      axios
      .get(
        `${globalConfig.systemCodesUrl}/TRANSFORMATION_STATUS`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
        const transformation_status = res.data;
        console.log(transformation_status );
        setStatus(transformation_status );
      });
	}
  	catch(x) {
  		toast.error("An error occurred while loading data : " + x.message);
  	}

	}
	else {
		toast.error("No valid transformer has been selected. Go back and select one first. Rerouting");
		//window.location.replace('/neo/transformers');
	}
  };
  const handleClear = (e) => {
  	e.preventDefault();
     setState(initialState);
  }


  const handleSave = (e) => {

    e.preventDefault();

	try {
		if (state.transformationId > 0)
		{
		
    var url = `${globalConfig.apiDatahubUrl}/transformations/${state.transformationId}`;

    axios
      .patch(url, state, globalConfig.hardcoded_header)
      .then((response2) => {
        console.log("response.data");
        if (response2.status === 200) {
          toast.success("Saved transformation successfully.");
        } else {
          toast.error("Failed to save transformation - " + response2.message);
        }
      })
      .catch((err) => {
          toast.error("Failed to save transformation - " + err.message);
      });
		
		}
		else
		{
			toast.error("Invalid transformation - Cannot save this record.");
		}

	}
	catch (x)
	{
		toast.error("An error occurred - " + x.message);
	}

  }

  const handleDelete = (event) =>  {
    event.preventDefault();
    //alert('deleting service with id = ' + state.scanJobId);

	if (state.transformationId > 0)
	{	
	try {

    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/transformations/${state.transformationId}`,
        globalConfig.hardcoded_header
      )
      .then((res) => {
          const response = res.data;

          console.log('response -> ' + response);
          if (res.status === 200) {
          	// success
          	toast.success('Transformer has been deleted');
          	handleClear(e);
          } else if (res.status === 404) {
	          // not found
    	      toast.error('Transformer deletion failed');
          } else {
    	      // handle other codes
    	      toast.error('Transformer deletion failed');
          }

        window.location.replace = "/neo/transformers";
      })
      .catch(error => {
    	      toast.error('Transformer deletion failed');
			    console.log(error.response.status);    // 404, 500, etc
    			console.log(error.response.data);      // error message from server
    			console.log(error.response.config.url); // exact URL it hit
  	});

	} catch (error) {
  		if (error.response) {
	    // Server responded with something outside 2xx
    	console.log('Status:', error.response.status);        // 404
    	console.log('URL hit:', error.response.config.url);   // exact URL it tried
    	console.log('Data:', error.response.data);            // error message from server
  		}
	}
    handleClear();
    }
    else {
    	toast.error("A valid transformer has not been selected.");
    }
  }

  return (
    <div className="container-fluid">

    <form>
      <div className="container-fluid">
	<div className="d-flex flex-row justify-content-between mb-3 mt-3">
        <h4>Manage Transformer (Agents)</h4>
			  <div>
            <Link to="/neo/create-transformer" className="btn-success btn">
              Create Transformer
            </Link>
            &nbsp;
            <Link to="/" className="btn-primary btn">
              Home
            </Link>
            &nbsp;
	        <Link to="/neo/transformers" className="btn btn-warning">
          		Back
	        </Link>
        	</div>
      </div>


        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Transformer Name">
            Transformer Name
          </label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="transformationName"
            value={state.transformationName}
            onChange={(e) => setState({...state, transformationName: e.target.value})}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Resource Endpoint/URL</label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="resourceFile"
            value={state.resourceFile}
            onChange={(e) => setState({...state, resourceFile: e.target.value})}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Service/Agent Name</label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="className"
            value={state.className}
            onChange={(e) => setState({...state, className: e.target.value})}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Description</label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="description"
            value={state.description}
            onChange={(e) => setState({...state, description: e.target.value})}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Version</label>
          <input
            className="form-control input-xlarge col-sm-8"
            id="transformationVersion"
            value={state.transformationVersion}
            onChange={(e) => setState({...state, transformationVersion: e.target.value})}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Status</label>
          {/* <SelectListComponent IdName="statusCode" onChange={this.handleChange} entityName ={"system-code-values"}
					valueFilterColumnName = {"systemCodeId"} valueFilter = {"95"} displayColumnName ={"systemCodeValueValue"}
					keyColumnName ={"systemCodeValueId"}/> */}

          <select
            partialSubmit="true"
            className="form-control input-xlarge col-sm-8"
            id="indexCode"
            value={state.statusCode}
            onChange={(e) => setState({...state, sttusCode: parseInt(e.target.value)})}
          >
            {/* <option value="#{ombSystemLookupCodesControl.getSystemCodeValuesSelectBox('TRANSFORMATION_STATUS')}" /> */}
            {status.map(
                  ({
                    systemCodeId,
                    systemCodeValueValue,
                    systemCodeValueId,
                  }) => (
                    <option key={systemCodeValueId} value={systemCodeId}>
                      {systemCodeValueValue}{" "}
                    </option>
                  )
                )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Parameters</label>
          <textarea
            className="form-control input-xlarge col-sm-8"
            id="parameters"
            value={state.parameters}
            onChange={(e) => setState({...state, parameters: e.target.value})}
          />
        </div>

        <div className="form-group row">
          <label className="ContentTitle col-sm-2">Upload Configuration</label>
          <input type="file" id="fileUpload" />
          <button
            type="submit"
            value="Upload"
            className="btn btn-info"
            id="uploadActor"
          >
            Upload
          </button>
        </div>

        <hr />
        <center>
          <div className="form-group row">
            <button className="btn btn-success" value="Save" 
            	onClick={(e) => {handleSave(e)}}
            >
              Save
            </button>
            &nbsp;
            <button
              className="btn btn-danger"
              value="Delete"
              onClick={(e) => {handleDelete(e)}}
            >
              Delete
            </button>
            &nbsp;
          </div>
        </center>
      </div>
    </form>
    </div>
  );
};

export default ManageTransformer;

//             <button
//               className="btn btn-primary"
//               value="Clear"
//               onClick={handleClear}
//               immediate="true"
//             >
//               Clear
//             </button>
//             &nbsp;

//   function handleChange(event) {
//     console.log(event);
//     var target = event.target;
//     console.log(target.id + ":" + target.value);
// 
//     setState({ ...state, [target.id]: target.value });
//     console.log(state);
//   }
